var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    zoomAndPan: "magnify",
    viewBox: "0 0 150 149.999998",
    height: 200,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e52d27",
    d: "M 150 127.203125 C 150 139.777344 139.777344 150 127.203125 150 L 22.796875 150 C 10.222656 150 0 139.777344 0 127.203125 L 0 22.796875 C 0 10.222656 10.222656 0 22.796875 0 L 127.203125 0 C 139.777344 0 150 10.222656 150 22.796875 Z M 150 127.203125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 128.167969 76.1875 C 128.167969 84.480469 128.167969 93.269531 126.316406 101.304688 C 125.011719 106.964844 120.394531 111.109375 114.816406 111.738281 C 101.644531 113.199219 88.289062 113.222656 75.011719 113.199219 C 61.710938 113.199219 48.410156 113.199219 35.210938 111.738281 C 29.65625 111.109375 25.011719 106.964844 23.707031 101.304688 C 21.855469 93.269531 21.855469 84.480469 21.855469 76.1875 C 21.855469 67.890625 21.882812 59.101562 23.707031 51.070312 C 25.011719 45.410156 29.628906 41.261719 35.210938 40.636719 C 48.410156 39.148438 61.738281 39.148438 75.011719 39.148438 C 88.289062 39.148438 101.617188 39.148438 114.816406 40.636719 C 120.371094 41.261719 125.011719 45.410156 126.316406 51.070312 C 128.167969 59.101562 128.167969 67.890625 128.167969 76.1875 Z M 128.167969 76.1875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#e52d27",
    d: "M 63.824219 56.417969 L 63.824219 96.140625 L 94.679688 76.265625 Z M 63.824219 56.417969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.e1355b7726162009a14b531d1b04d02a.svg";
export { ForwardRef as ReactComponent };